module.exports = __webpack_public_path__ + "static/RootSans-9Bold-a408356a3bdc6a4c85c2620e7dfe2ad8.woff";